import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ShareService } from "../../../core/core";

@Component({
  selector: "common-reserve-section",
  templateUrl: "./reserve-section.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReserveSectionComponent {
  constructor(private shareService: ShareService) {}

  share(): void {
    const origin =
      typeof window !== "undefined" && window.location?.origin ? window.location.origin : "https://www.rubbl.com";
    this.shareService.share(
      "Rubbl Connect — Put your machines, trucks and crew to work",
      "Earn from idle equipment, hauling, and service — free, with no signup required.",
      `${origin}/connect`,
      { target: "home-connect-section-share" },
    );
  }
}
